import React from "react";
import PropTypes from "prop-types";
import isArray from "lodash/isArray";
import {Enum} from "@morningtrain/helpers";
import {useCollection} from "@morningtrain/react-resources";
import groupBy from "lodash/groupBy";
import isEqual from "lodash/isEqual";
import {autorun, toJS} from "mobx";

function resolveOptions(props, collection) {

    const {options} = props;

    const collectionLength = collection && collection.length ? collection.length : 0;

    if (isArray(options)) {
        if (options.length > 0) {
            return options;
        }
    } else if (typeof (options) === 'object') {

        const optionKeys = Object.keys(options);

        return optionKeys.map(key => {
            return {value: key, label: options[key]};
        });
    }

    if (typeof (props.enum) !== 'undefined') {
        return (new Enum(props.enum)).options;
    }


    if (collectionLength) {

        let collectionOptions = [];
        let collectionKeyedByValue = {};

        if (props.modifyCollection) {
            collectionOptions = props.modifyCollection(collection);
        } else if (props.optionsKey) {
            collectionOptions = collection.map((val, index) => {
                const valId = (typeof val.get === 'function') ? val.get('id') : val['id'];
                collectionKeyedByValue[valId] = val;
                return {
                    value: valId,
                    label: (typeof val.get === 'function') ? val.get(props.optionsKey) : val[props.optionsKey]
                };
            });
        } else {
            collectionOptions = toJS(collection);
        }

        if(props.groupOptionsBy) {
                return groupBy(collectionOptions, entry => {
                   let collectionEntry = collectionKeyedByValue[entry.value];

                   const groupKey = (typeof collectionEntry.get === 'function') ? collectionEntry.get(props.groupOptionsBy) : collectionEntry[props.groupOptionsBy];

                   return groupKey || props.defaultGroupKey;
                });
        }

        return collectionOptions;
    }

    return [];
}

function useFieldOptions(props) {

    const collection = useCollection();

    function determineOptions() {
        let resolvedOptions = resolveOptions(props, collection);

        let {only} = props;

        if (only && isArray(only)) {
            resolvedOptions = resolvedOptions.filter(option => {
                return only.indexOf(option.value) >= 0;
            });
        }

        return resolvedOptions || [];
    }

    const [options, setOptions] = React.useState(determineOptions());

    React.useEffect(() => {
        const disposer = autorun(() => {
            const nextOptions = determineOptions();
            if(!isEqual(options, nextOptions)) {
                setOptions(nextOptions);
            }
        }, {fireImmediately: true});

        return () => {
            disposer();
        }
    })

    return options;
}

useFieldOptions.defaultProps = {
    modifyCollection: null,
    only: null,
    options: [],
    optionsKey: null,
    groupOptionsBy: null,
    defaultGroupKey: null,
};

useFieldOptions.propTypes = {
    modifyCollection: PropTypes.func,
    only: PropTypes.array,
    options: PropTypes.oneOfType([
        PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string.isRequired,
                value: PropTypes.any.isRequired,
            })
        ),
        PropTypes.object
    ]),
    optionsKey: PropTypes.string,
    groupOptionsBy: PropTypes.string,
    defaultGroupKey: PropTypes.string,
};

export default useFieldOptions;
